import { render, staticRenderFns } from "./OverviewOpg.vue?vue&type=template&id=43677ef3"
import script from "./OverviewOpg.vue?vue&type=script&lang=js"
export * from "./OverviewOpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports